// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2N_wr","head":"ProcedureTableInfo_head__EpCJT"};